import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { paths } from '@/constants/paths';
import { OryConstants } from '@/constants/oryContstants';

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const login = (returnTo?: string) => {
    setLoading(true);
    let path = paths.login;
    if (returnTo) {
      const encodedReturnToPath = encodeURIComponent(returnTo);
      path = `${paths.login}?${OryConstants.returnTo}=${encodedReturnToPath}`;
    }
    router.push(path);
  };

  return { login, loading };
};
